// Opening campaigns in the Campaign Studio, which has its own addresses:
//   /marketing-campaigns/new           where to start
//   /marketing-campaigns/new/<source>  a new one from a plan, a season or nothing
//   /marketing-campaigns/<id>          a saved one
// A plan is handed to the studio through this tab's session storage, so a
// refresh keeps it; the studio can also find it again by its key.

export const LIST_PATH = '/marketing-campaigns'
export const NEW_PATH = '/marketing-campaigns/new'
const SEED = 'beu-campaign-seed'

export const campaignPath = id => `${LIST_PATH}/${encodeURIComponent(id)}`

// The address for a plan (Bailey's, a season's, or a blank one), handing it over
export const planPath = (plan) => {
  const source = (plan && plan.key) || 'blank'
  try { sessionStorage.setItem(SEED, JSON.stringify({ source, plan })) } catch (e) { /* private mode: the studio finds it by its key */ }
  return `${NEW_PATH}/${encodeURIComponent(source)}`
}

export const readSeed = (source) => {
  try {
    const v = JSON.parse(sessionStorage.getItem(SEED) || 'null')
    return v && v.source === source && v.plan ? v.plan : null
  } catch (e) { return null }
}

export const forgetSeed = () => { try { sessionStorage.removeItem(SEED) } catch (e) { /* ignore */ } }

// A saved campaign as the studio edits it, and back
export const asDraft = c => ({ ...c, title: c.name || c.title || 'Campaign', key: c.planKey || null })

export const toRecord = (draft, extra = {}) => ({
  id: draft.id || undefined,
  name: draft.title || 'Campaign',
  why: draft.why || '',
  kind: draft.kind || 'yours',
  planKey: draft.key || draft.planKey || null,
  start: draft.start,
  end: draft.end,
  audience: draft.audience || null,
  items: draft.items || [],
  look: draft.look || null,
  moment: draft.moment || null,
  event: draft.event || null,
  eventDate: draft.eventDate || null,
  palette: draft.palette || null,
  notes: draft.notes || [],
  copiedFrom: draft.copiedFrom || null,
  status: draft.status || 'draft',
  created: draft.created || {},
  createdAt: draft.createdAt,
  approvedAt: draft.approvedAt || null,
  ...extra,
})
